import { initConfig } from '@cian/config/browser';
import { init as initGlobalBehaviors } from '@cian/global-behaviors/browser';
import { initLogger } from '@cian/logger/browser';
import { init as initTelemetry } from '@cian/telemetry/browser';
import { init as initHttpApi } from '@cian/http-api/browser';
import { init as initWeb } from '@cian/web/browser';
import { initWebview } from '@cian/webview/webview';

export function initDependencies() {
  initConfig();
  initLogger();
  initTelemetry();
  initHttpApi();
  initWeb();
  initGlobalBehaviors();
  initWebview();
}
